import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import zhCN from './resources/zh-CN.json';
import zhHK from './resources/zh-HK.json';
import ja from './resources/ja.json';
import ko from './resources/ko.json';
import en from './resources/en.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      'zh-CN': { translation: zhCN },
      'zh-HK': { translation: zhHK },
      'ja': { translation: ja },
      'ko': { translation: ko },
      'en': { translation: en }
    },
    fallbackLng: 'zh-CN',
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage']
    }
  });

export default i18n;
